export enum VideoRoomErrors {
    ICE_FAILED = 'ICE failed'
}
